import { isObject, objectWithRandomUniqueKey } from '../../../../common/utils';
import { AlgorithmJoinValidFormDataType } from './types';

export const getDefaultAlgorithmJoinItemFormData = () =>
  objectWithRandomUniqueKey({
    _variant: 'DIMENSION_DIMENSION' as const,
    algorithmSourceId: null!,
    sourceDimension: '',
    targetDimension: '',
  });

const firstDefaultAlgorithmJoinFormData = {
  algorithmSourceId: null!,
  joinTypeCode: null,
  algorithmJoinItems: [],
};

export const getSubsequentAlgorithmJoinDefaultFormData = () => ({
  algorithmSourceId: null!,
  joinTypeCode: 'FULL_OUTER' as const,
  algorithmJoinItems: [getDefaultAlgorithmJoinItemFormData()],
});

export const getDefaultAlgorithmJoinFormData = () => [
  firstDefaultAlgorithmJoinFormData,
  getSubsequentAlgorithmJoinDefaultFormData(),
];

export const isEqualToDefaultAlgorithmJoinFormData = (data: any): boolean =>
  Array.isArray(data) &&
  data.length === 2 &&
  data.every(isObject) &&
  isEmptyJoin(data[0], null, 0) &&
  isEmptyJoin(data[1], 'FULL_OUTER', 1);

const isEmptyJoin = (
  join: object,
  typeCode: AlgorithmJoinValidFormDataType['joinTypeCode'],
  numEmptyItems: number,
) => {
  if (
    'algorithmSourceId' in join &&
    join.algorithmSourceId === null &&
    'joinTypeCode' in join &&
    join.joinTypeCode === typeCode &&
    'algorithmJoinItems' in join &&
    Array.isArray(join.algorithmJoinItems) &&
    join.algorithmJoinItems.length === numEmptyItems
  ) {
    if (numEmptyItems > 0) {
      for (const item of join.algorithmJoinItems) {
        if (
          ('algorithmMappingAlias' in item && item.algorithmMappingAlias) ||
          ('sourceDimension' in item && item.sourceDimension) ||
          ('targetDimension' in item && item.targetDimension) ||
          ('sourceValue' in item && item.sourceValue) ||
          ('targetValue' in item && item.targetValue)
        ) {
          return false;
        }
      }
    }
    return true;
  }

  return false;
};
